module.exports = __webpack_public_path__ + "static/media/exit.83c217ae.svg";